import { type BaseNotificationItemProps, NotificationItem } from '../components/NotificationItem'

export type EligibilityEnabledProps = BaseNotificationItemProps & {
  type: 'eligibility_enabled'
  program: {
    id: string
    displayName: string
    color: string
    iconType?: string
  }
}

export function EligibilityEnabled({ program, ...props }: EligibilityEnabledProps) {
  return (
    <NotificationItem
      {...props}
      title={`${program.displayName} Eligibility Enabled`}
      descriptionAddon={
        <p className='flex text-sm text-gray-500'>{`You are now eligible to work on ${program.displayName}.`}</p>
      }
    />
  )
}
